import React, { useMemo } from 'react';
import CardConsolidationResultStyled from './CardConsolidationResultStyled';
import DataTableNativeML from '@/components/DataTableNativeML';
import { useTheme } from '@material-ui/core';
import { useSelector } from 'dva';
import { useIntl } from 'umi';
import { createOid } from '@/utils/eventtracing';

const CardConsolidationResult = (props) => {
  const { onSetAdmin, onSetSecondary, adminId, secondaryId } = props;
  // const pageData = props.pageData;
  const theme = useTheme();
  const intl = useIntl();
  const { formatMessage } = intl;

  const memberPageList = useSelector(
    (state) => state.memberManagement.memberPageList,
  );

  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['memberManagement/getMemberList'];

  const { data, total } = memberPageList || {};
  const [firstData] = data || [];

  const isAdmin = useMemo(() => {
    if (firstData || adminId) {
      return firstData?.id === adminId;
    }
  }, [firstData, adminId]);

  const isSecond = useMemo(() => {
    if (firstData || secondaryId) {
      return firstData?.id === secondaryId;
    }
  }, [firstData, secondaryId]);

  // 设置主卡
  const handleSetAdmin = (card) => {
    onSetAdmin && onSetAdmin(card);
  };

  // 设置副卡
  const handleSetSecondary = (card) => {
    onSetSecondary && onSetSecondary(card);
  };

  const columns = [
    {
      // title: '会员号',
      title: formatMessage({ id: 'adjustment.members.c01.lbl01' }),
      align: 'center',
      id: 'memberCode',
      key: 'memberCode',
      width: 95,
    },
    {
      // title: '会员姓名',
      title: formatMessage({ id: 'adjustment.members.c01.lbl02' }),
      align: 'center',
      id: 'name',
      key: 'name',
      width: 95,
    },
    {
      // title: '手机号',
      title: formatMessage({ id: 'adjustment.members.c01.lbl03' }),
      align: 'center',
      id: 'mobile',
      key: 'mobile',
      width: 95,
    },
    {
      // title: '会员等级',
      title: formatMessage({ id: 'adjustment.members.c01.lbl05' }),
      align: 'center',
      id: 'level',
      key: 'level',
      width: 95,
    },
    {
      // title: '总剩余积分',
      title: formatMessage({ id: 'adjustment.members.merge.n01.lbl01' }),
      align: 'center',
      // id: 'totalPoint',
      // key: 'totalPoint',
      render: ({ totalPoint }) => {
        return <div align="center">{totalPoint || 0}</div>;
      },
      width: 95,
    },
    {
      // title: '操作',
      title: formatMessage({ id: 'adjustment.members.c01.lbl12' }),
      // width: 120,
      align: 'center',
      // 卡号没有设置的时候为蓝色可以点击
      render: (item) => {
        return (
          <div align="center" className="card-action-wrap">
            <span
              data-log={JSON.stringify({
                oid: createOid('ec'),
                events: ['_ev', '_ec'],
                params: {
                  id: item.id,
                },
              })}
              onClick={() => handleSetAdmin(item)}
              className="set-admin-card"
            >
              {/* 设为主卡 */}
              {formatMessage({ id: 'adjustment.merge.n01.lbl02' })}
            </span>
            <span className="card-divider">|</span>
            <span
              data-log={JSON.stringify({
                oid: createOid('ec'),
                events: ['_ev', '_ec'],
                params: {
                  id: item.id,
                },
              })}
              onClick={() => handleSetSecondary(item)}
              className="set-second-card"
            >
              {/* 设为副卡 */}
              {formatMessage({ id: 'adjustment.merge.n01.lbl03' })}
            </span>
          </div>
        );
      },
      width: 200,
    },
  ];

  return (
    <CardConsolidationResultStyled
      theme={theme}
      isSecond={isSecond}
      isAdmin={isAdmin}
    >
      <div className="card-list-wrap">
        <DataTableNativeML
          total={total}
          loading={loading}
          paging={true}
          columns={columns}
          pageButton={false}
          data={data}
        ></DataTableNativeML>
      </div>
    </CardConsolidationResultStyled>
  );
};

export default CardConsolidationResult;
